import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-po-finish-prod-comps-bs',
  templateUrl: './po-finish-prod-comps-bs.component.html',
  styleUrls: ['./po-finish-prod-comps-bs.component.css']
})
export class PoFinishProdCompsBsComponent implements OnInit {
    p2PoFinishProdCompKeyno;

    public itemsListComponents: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2PoFinishProdCompKeyno = this.stateService.getStateParams()['p2_pofinishprodcomp_keyno'];
    }

    private async loadComponents() {
        if (!!this.p2PoFinishProdCompKeyno) {
            this.itemsListComponents = await this.datatask.Post(172, { p2_pofinishprodcomp_keyno: this.p2PoFinishProdCompKeyno });
        }
    }

    private async init() {
        this.loadComponents();
    }

    ngOnInit() {
        this.init();
    }
}
